import { UserStatus } from '@shared/model/user';
import { GetUserStatus } from './types';

export const getUserStatus: GetUserStatus = ({ active, emailVerified }) => {
    if (active === false) {
        return UserStatus.Disabled;
    }
    if (emailVerified === false) {
        return UserStatus.WaitingActivation;
    }
    return UserStatus.Active;
};
